import type { ReactNode } from 'react';
import { memo } from 'react';
import { clsx } from 'clsx';
import { Paragraph } from '@library';
import styles from './DiscountBadge.module.css';

const DiscountBadge = ({
    percentage,
    type,
    text = null,
    ...ariaProps
}: {
    percentage: number;
    type: 'personal' | 'sale';
    text?: ReactNode;
}) => (
    <div
        {...ariaProps}
        className={clsx(styles.badge, {
            [styles.personal]: type === 'personal',
            [styles.sale]: type === 'sale',
        })}
        data-test-class={
            type === 'sale'
                ? 'saleDiscountPercentage'
                : 'dealerDiscountPercentage'
        }
    >
        <Paragraph caption uppercase bold>
            {text || `-${Math.round(percentage)}%`}
        </Paragraph>
    </div>
);

export default memo(DiscountBadge);
